import { render, staticRenderFns } from "./nonMerMain.vue?vue&type=template&id=66539ec0&"
import script from "./nonMerMain.vue?vue&type=script&lang=js&"
export * from "./nonMerMain.vue?vue&type=script&lang=js&"
import style0 from "./nonMerMain.vue?vue&type=style&index=0&id=66539ec0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports